const topicTags = [
  { name: '顶流恋爱', count: '128万', hot: true },
  { name: '选秀内幕', count: '96万', hot: true },
  { name: '税务风波', count: '85万', hot: true },
  { name: '直播翻车', count: '73万', hot: true },
  { name: '综艺冲突', count: '67万', hot: false },
  { name: '合约纠纷', count: '58万', hot: false },
  { name: '女星互撕', count: '52万', hot: false },
  { name: '资本博弈', count: '41万', hot: false },
  { name: '导演争议', count: '36万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">大家都在关注的吃瓜话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full font-medium text-sm transition-all cursor-pointer ${
                tag.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600 shadow-lg shadow-primary-500/20'
                  : 'bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {tag.hot && <i className="ri-fire-fill text-xs"></i>}
              <span>{tag.name}</span>
              <span className={`text-xs ${
                tag.hot ? 'text-background-50/70' : 'text-foreground-400'
              }`}>
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}